import { render } from "./cardMessage.vue?vue&type=template&id=33a2f322&scoped=true"
import script from "./cardMessage.vue?vue&type=script&lang=js"
export * from "./cardMessage.vue?vue&type=script&lang=js"

import "./cardMessage.vue?vue&type=style&index=0&id=33a2f322&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a2f322"]])

export default __exports__